module.exports = __webpack_public_path__ + "img/ligas-noticias.1390f408.png";